import type {ReactNode} from 'react'
import {useReveal} from '@/hooks/common/use-reveal'
import {cn} from '@/lib/utils'

/** `delayMs` goes as an inline style: Tailwind has no arbitrary transition-delay utility. */
export function Reveal({
  as: As = 'div',
  delayMs = 0,
  className,
  children,
}: {
  as?: 'div' | 'li' | 'section'
  delayMs?: number
  className?: string
  children: ReactNode
}) {
  const {ref, revealed} = useReveal<HTMLDivElement>()
  return (
    <As
      ref={ref as never}
      data-revealed={revealed}
      className={cn('reveal', className)}
      style={delayMs ? {transitionDelay: `${delayMs}ms`} : undefined}>
      {children}
    </As>
  )
}
